module.exports = __webpack_public_path__ + "static/media/healthy-breakfast1440.1aefa3d4.jpeg";